export default [
  { prefix: '83.221.192.0/19', count: 22, protocol: 'ip' },
  { prefix: '80.68.0.0/21', count: 5, protocol: 'ip' },
  { prefix: '93.178.96.0/22', count: 4, protocol: 'ip' },
  { prefix: '73.178.96.0/22', count: 4, protocol: 'ip' },
  { prefix: '53.178.96.0/22', count: 4, protocol: 'ip' },
  { prefix: '63.178.96.0/22', count: 4, protocol: 'ip' },
  { prefix: '93.178.96.0/22', count: 1, protocol: 'telnet' },
  { prefix: '93.178.96.0/22', count: 1, protocol: 'ssh' },
  { prefix: '73.178.96.0/22', count: 1, protocol: 'telnet' },
  { prefix: '73.178.96.0/22', count: 1, protocol: 'ssh' }
];
